<template>
  <md-field>
    <label>{{label}}</label>
    <md-input v-if="!isDisabled" :value="value.reduce(reducer)"></md-input>
    <md-input v-else :value="value.reduce(reducer)" disabled></md-input>
  </md-field>
</template>

<script>
  export default {
    name: 'MultiValueInput',
    props: {
      value: Array,
      isDisabled: {
        type: Boolean,
        default: false
      },
      label: String
    },
    data () {
      return {
        reducer: (accumulator, currentValue) => `${currentValue}, ${accumulator}`
      }
    },
  }
</script>

<style scoped>

</style>